import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {action} from 'mobx';
import { Router, Route, Switch } from "react-router";

import AppBar from 'material-ui/AppBar';
import Paper from 'material-ui/Paper';

import './App.css';
import store from './store/store.js'
import api from './api/server_api.js'


import Circle from './sys/Circle.jsx'
import LightBoxMob from './coms/LightBoxMob.jsx'
import DialogMob from './coms/DialogMob.jsx'
import Orders from './pages/Orders.jsx'
import NewOrder from './pages/NewOrder.jsx'
import NewOrderSettings from './pages/NewOrderSettings.jsx'

import Menu from './coms/Menu.jsx'
import BackButton from './coms/BackButton.jsx'

@observer
class App extends Component {

  componentWillMount(){
    const cb = action( (data, session) => {
      if (data) {
        store.auth.agentName = data.name;
        store.auth.session = session;
        store.auth.loged = true;
      } 
      else {
        store.auth.loged = false;
        store.auth.agentName = '';
        store.auth.session = '';
        localStorage.removeItem('session');
        store.replacePage('/login');
      }
    } ) // end cb
    let session = '';
    if (store.auth.session !== '') {session = store.auth.session}
      else {
        try { session = localStorage.getItem('session'); }
            catch (e) {}
      }
    if (session) {
      api.check(session, cb);
    }
    else store.replacePage('/login');

  }

  logout() {
    localStorage.removeItem('session');
    store.replacePage('/login');
  }

  render() {

    var {loged, agentName} = store.auth;

    if (!loged) return <div> <br/> <br/> <br/> <Circle /></div>

    else return (
      <div >
        <AppBar 
          style={{minWidth:1000}}
          title = {agentName}
          titleStyle = {{textAlign: 'left'}}
          showMenuIconButton = {true}
          //iconElementLeft= {<h4>{agentName}</h4>}
          iconElementRight= {<Menu logout={this.logout} />}
          iconElementLeft= {<BackButton />}
        />

        <Paper
          style={{minHeight: window.innerHeight - 64, minWidth: 1000, maxWidth: 1040, margin: "auto", padding: 20}}
        >
          
          <Switch>
            <Route exact path="/" component={Orders} />
            <Route exact path="/neworder" component={NewOrder} />
            <Route exact path="/neworder/rzhd" component={() => <NewOrderSettings type='r' />} />
            <Route exact path="/neworder/auto" component={() => <NewOrderSettings type='a' />} />
          </Switch>
        </Paper>
        <DialogMob />
        <LightBoxMob />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx